import React from 'react';

import styled from 'styled-components';

import { MyCommunitiesRateGap } from 'types/recommendations';

import { getCompetitorComparisonLabel } from '../constants';
import ClickableCellValue from './ClickableCellValue';

const SmallText = styled.span`
  font-size: 12px;
  color: var(--text-secondary);
`;

const Container = styled.div`
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.positive {
    color: var(--positive-green);
  }
  &.negative {
    color: var(--inactive-orange);
  }
`;

const Subtitle = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

type Props = {
  rateGap: MyCommunitiesRateGap | null;
  onClick: () => void;
};

const RateGapCell = ({ rateGap, onClick }: Props) => {
  if (!rateGap) {
    return <SmallText>-</SmallText>;
  }

  const roundedPercent = Math.round(rateGap.diff_percent);
  const isPositive = roundedPercent < 0;

  return (
    <ClickableCellValue onClick={onClick} dataTestId="my-communities-rate-gap-cell" withChevron>
      <Container className={isPositive ? 'positive' : 'negative'}>
        {rateGap.care_type_abv} · {rateGap.room_type} {roundedPercent > 0 ? '+' : ''}
        {roundedPercent}%
      </Container>
      <Subtitle>{getCompetitorComparisonLabel(rateGap.competitor_count)}</Subtitle>
    </ClickableCellValue>
  );
};

export default RateGapCell;
